import { ReactNode } from "react";
import { isBackendPending } from "@/config/backendPending";
import BackendPendingPage from "@/components/BackendPendingPage";

interface BackendPendingGateProps {
  /** Sidebar menu `id` this route maps to (e.g. "billing", "admin"). */
  menuId: string;
  /** Title shown on the pending panel when the id is gated. */
  title: string;
  /** Copy override forwarded to the pending panel. */
  description?: string;
  /**
   * The real page. Optional: two gated routes (analytics, system administration)
   * have their page files deleted, so the gate renders with no children.
   */
  children?: ReactNode;
}

/**
 * RUNTIME gate. If `menuId` is in `BACKEND_PENDING_MENU_IDS`, it renders the
 * honest `BackendPendingPage` instead of the route's page; otherwise it renders
 * `children` unchanged.
 *
 * The gating is decided at render time from the registry — NOT by statically
 * swapping the route's element — so re-enabling a page is a single deletion from
 * `src/config/backendPending.ts` and nothing else.
 */
export default function BackendPendingGate({
  menuId,
  title,
  description,
  children,
}: BackendPendingGateProps) {
  if (isBackendPending(menuId)) {
    return <BackendPendingPage title={title} description={description} />;
  }

  return <>{children}</>;
}
